import { clsx } from "@trydig/ui";
import styles from "./tags.module.css";

export const Tags = ({ activeTag }: { activeTag?: string | null }) => {
	if (!activeTag) return null;

	return (
		<div className={styles["product-card__tags"]} product-card-tags={"true"}>
			<div className={clsx(styles["product-card__tag"], styles[`product-card__tag__${activeTag}`])}>
				<p>{activeTag}</p>
			</div>
		</div>
	);
};
